import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { performApiRequest, invalidateApiDataRequest, getApiDataRequest } from '../../redux/apiData';
import { openModal } from '../../redux/modal';
import withMatch from '@/hocs/withMatch';
// Services
import withApiData from '../../services/withApiData';
import formatPrice from '../../services/formatPrice';

// Components
import Link from '@/components/atoms/Link';
import Paragraph from '../shared/richText/Paragraph';
import BBCode from '../shared/richText/BBCode';
import PriceStructure from '../PriceStructure';
import ButtonDownload from '../shared/buttons/ButtonDownload';
import Radio from '../shared/forms/fieldTypes/Radio';
import TextArea from '../shared/forms/fieldTypes/Textarea';
import ButtonPrimary from '../shared/buttons/ButtonPrimary';
import Checkbox from '../shared/forms/fieldTypes/Checkbox';

// Styles
import { colorPalette, colorPaletteRGB, shadows, textStyles } from '../../styles/styleGuide';
import { toBreakpoint, fromBreakpoint } from '../../styles/breakpoints';
import onNetworkStatusChange from '@/processes/onNetworkStatusChange';
var connectApiData = withApiData({
  orderDetails: 'getOptionOrder'
}, function (ownProps) {
  return {
    orderDetails: {
      projectSlug: ownProps.match.params.projectSlug,
      orderId: ownProps.orderId
    },
    options: {
      cache: "disabled"
    }
  };
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    postOptionOrderResult: getApiDataRequest(state.apiData, 'postOptionOrder', {
      projectSlug: ownProps.projectSlug,
      orderId: ownProps.orderId
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    wishListId = _ownProps$match$param.wishListId;
  var orderId = ownProps.orderId;
  return {
    postOptionOrder: function postOptionOrder(values) {
      dispatch(performApiRequest('postOptionOrder', {
        projectSlug: projectSlug,
        orderId: orderId
      }, values));
    },
    invalidateData: function invalidateData() {
      dispatch(invalidateApiDataRequest('postOptionOrder', {
        projectSlug: projectSlug,
        orderId: orderId
      }));
      if (wishListId) {
        dispatch(invalidateApiDataRequest('getWishList', {
          projectSlug: projectSlug,
          wishListId: wishListId
        }));
      }
      dispatch(invalidateApiDataRequest('getSettings', {
        projectSlug: String(projectSlug),
        env: 'closed'
      }));
      dispatch(invalidateApiDataRequest('getPage', {
        pagePath: String(projectSlug) + '/closed'
      }));
    },
    openNextModal: function openNextModal(modalObject) {
      dispatch(openModal(colorPalette.blue, modalObject));
    }
  };
};
var ProductOptionConfirmModal = /*#__PURE__*/function (_Component) {
  function ProductOptionConfirmModal() {
    var _this;
    _classCallCheck(this, ProductOptionConfirmModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProductOptionConfirmModal, [].concat(args));
    _defineProperty(_this, "state", {
      submitted: false,
      canSubmit: false,
      values: {
        attachmentsAgreed: false,
        attachmentsReason: '',
        attachmentsReasonVisible: false,
        additionsAgreed: false,
        additionsReason: '',
        additionsReasonVisible: false
      },
      termsValid: true,
      termsChecked: false
    });
    _defineProperty(_this, "handleConfirmationSelection", function (evt) {
      if (!evt) return;
      var target = evt.target;
      var fieldName = target.name;
      var value = target.value === 'true';
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          values: _objectSpread(_objectSpread({}, prevState.values), {}, _defineProperty(_defineProperty({}, "".concat(fieldName, "Agreed"), value), "".concat(fieldName, "ReasonVisible"), !value)),
          termsChecked: false,
          termsValid: true
        });
      }, _this.checkSubmission);
    });
    _defineProperty(_this, "handleReasonComment", function (evt) {
      if (!evt) return;
      var target = evt.target;
      var fieldName = target.name;
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          values: _objectSpread(_objectSpread({}, prevState.values), {}, _defineProperty({}, fieldName, target.value))
        });
      }, _this.checkSubmission);
    });
    _defineProperty(_this, "handleCheckClick", function () {
      var termsChecked = _this.state.termsChecked;
      _this.setState({
        termsValid: !termsChecked,
        termsChecked: !termsChecked
      });
    });
    _defineProperty(_this, "checkSubmission", function () {
      var orderDetails = _this.props.orderDetails;
      var data = orderDetails.data;
      var values = _this.state.values;
      var validation = [true]; // One default value to ensure validation works without documents

      if (data) {
        var attachmentsReasonValid = values.attachmentsReason !== '';
        var attachmentsValid = values.attachmentsAgreed || !values.attachmentsAgreed && attachmentsReasonValid;
        validation.push(attachmentsValid);
        if (data.hasTechnicalDrawing) {
          var additionsReasonValid = values.additionsReason !== '';
          var additionsValid = values.additionsAgreed || !values.additionsAgreed && additionsReasonValid;
          validation.push(additionsValid);
        }
      }
      var result = validation.every(function (item) {
        return item === true;
      });
      _this.setState({
        canSubmit: result
      });
      return result;
    });
    _defineProperty(_this, "handleSubmit", function () {
      var _this$props = _this.props,
        postOptionOrder = _this$props.postOptionOrder,
        orderId = _this$props.orderId,
        projectSlug = _this$props.projectSlug,
        openNextModal = _this$props.openNextModal,
        categories = _this$props.categories;
      var _this$state = _this.state,
        canSubmit = _this$state.canSubmit,
        values = _this$state.values,
        termsChecked = _this$state.termsChecked;
      var hasReason = values.attachmentsReasonVisible && values.attachmentsReason !== '' || values.additionsReasonVisible && values.additionsReason !== '';
      var hasCheckbox = !hasReason;
      if (canSubmit) {
        var statusOrder = values.attachmentsAgreed ? 'confirm_order' : 'deny_order';
        var statusDocument = values.additionsAgreed ? 'confirm_document' : 'deny_document';
        var orderData = {
          order_status: statusOrder,
          order_comment: statusOrder === 'deny_order' ? values.attachmentsReason : '',
          document_status: statusDocument,
          document_comment: statusDocument === 'deny_document' ? values.additionsReason : '',
          confirmation: termsChecked
        };
        if (hasCheckbox && !termsChecked) {
          _this.setState({
            termsValid: false
          });
        } else if (hasCheckbox && termsChecked) {
          openNextModal({
            type: 'orderVerification',
            componentProps: {
              orderId: orderId,
              projectSlug: projectSlug,
              categories: categories,
              hideCloseButtons: true
            }
          });
        } else if (hasReason) {
          postOptionOrder(orderData);
        }
      }
    });
    return _this;
  }
  _inherits(ProductOptionConfirmModal, _Component);
  return _createClass(ProductOptionConfirmModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        orderDetails = _this$props2.orderDetails,
        postOptionOrderResult = _this$props2.postOptionOrderResult,
        orderId = _this$props2.orderId,
        projectSlug = _this$props2.projectSlug,
        openNextModal = _this$props2.openNextModal,
        categories = _this$props2.categories,
        invalidateData = _this$props2.invalidateData;
      if (orderDetails.data && orderDetails.data !== prevProps.orderDetails.data) {
        this.checkSubmission();
      }
      if (postOptionOrderResult && postOptionOrderResult.networkStatus === 'success' && prevProps.postOptionOrderResult.networkStatus !== 'success') {
        openNextModal({
          type: 'orderConfirmation',
          componentProps: {
            projectSlug: projectSlug,
            orderId: orderId,
            confirmed: false,
            success: true,
            categories: categories,
            hideCloseButtons: true
          }
        });
      } else if (postOptionOrderResult && postOptionOrderResult.networkStatus === 'failed' && prevProps.postOptionOrderResult.networkStatus !== 'failed') {
        openNextModal({
          type: 'orderConfirmation',
          componentProps: {
            projectSlug: projectSlug,
            orderId: orderId,
            confirmed: false,
            success: false,
            categories: categories
          }
        });
      }
      onNetworkStatusChange({
        onSucces: invalidateData
      }, prevProps.postOptionOrderResult, postOptionOrderResult);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        projectSlug = _this$props3.projectSlug,
        orderDetails = _this$props3.orderDetails;
      var _this$state2 = this.state,
        canSubmit = _this$state2.canSubmit,
        values = _this$state2.values,
        termsValid = _this$state2.termsValid;
      var data = orderDetails.data;
      var hasReason = values.attachmentsReasonVisible && values.attachmentsReason !== '' || values.additionsReasonVisible && values.additionsReason !== '';
      return data ? __jsx(Container, {
        "data-id": "homestudio_ProductOptionConfirmModal_Container"
      }, __jsx(Content, {
        "data-id": "homestudio_ProductOptionConfirmModal_Content"
      }, __jsx(Title, {
        "data-id": "homestudio_ProductOptionConfirmModal_Title"
      }, "Kopersoptie ter bevestiging"), __jsx(Paragraph, {
        "data-id": "homestudio_ProductOptionConfirmModal_Paragraph"
      }, "We hebben de goedgekeurde opties verwerkt en verzoeken om hieronder de optiespecificatie en de verwerking op koperstekening te controleren en aan ons te bevestigen indien akkoord. Hulp nodig? Neem contact op met je woonadviseur"), __jsx(Section, {
        "data-id": "homestudio_ProductOptionConfirmModal_Section"
      }, __jsx(SectionTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_SectionTitle"
      }, "Optiespecificatie"), __jsx(OptionTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_OptionTitle"
      }, data.option.title), __jsx(OptionPrice, {
        "data-id": "homestudio_ProductOptionConfirmModal_OptionPrice"
      }, formatPrice(data.salesPrice, {
        showDecimal: true,
        showEuroSign: true
      })), data.option.optionCode && __jsx(OptionCode, {
        "data-id": "homestudio_ProductOptionConfirmModal_OptionCode"
      }, "Optiecode: ", data.option.optionCode), __jsx(OptionDescription, {
        "data-id": "homestudio_ProductOptionConfirmModal_OptionDescription"
      }, data.option.text && __jsx(BBCode, {
        content: data.option.text,
        "data-id": "homestudio_ProductOptionConfirmModal_BBCode"
      })), __jsx(PriceStructure, {
        priceStructure: data.option.priceStructure,
        totalPrice: data.option.price,
        "data-id": "homestudio_ProductOptionConfirmModal_PriceStructure"
      }), data.amount > 1 && __jsx(PriceAmountContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountContainer"
      }, __jsx(PriceAmountTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountTitle"
      }, "Optie aantal"), __jsx(PriceAmountLabel, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountLabel"
      }, data.amount, " (\xE1", ' ', formatPrice(data.salesPrice, {
        showDecimal: true,
        showEuroSign: true
      }), " per stuk)"), __jsx(PriceAmountTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountTitle"
      }, "Totaal bedrag"), __jsx(PriceAmountLabel, {
        "data-id": "homestudio_ProductOptionConfirmModal_PriceAmountLabel"
      }, formatPrice(data.salesPrice * data.amount, {
        showDecimal: true,
        showEuroSign: true
      }))), __jsx(SubSection, {
        "data-id": "homestudio_ProductOptionConfirmModal_SubSection"
      }, data.option.externalFiles && data.option.externalFiles.length > 0 && __jsx(React.Fragment, null, __jsx(SubSectionTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_SubSectionTitle"
      }, "Bijlagen"), __jsx(DownloadContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_DownloadContainer"
      }, data.option.externalFiles.map(function (file) {
        return __jsx(ButtonDownload, {
          key: "bijlagen-".concat(file.name),
          content: file.name,
          link: file.url,
          "data-id": "homestudio_ProductOptionConfirmModal_ButtonDownload"
        });
      }))), __jsx(ConfirmBox, {
        "data-id": "homestudio_ProductOptionConfirmModal_ConfirmBox"
      }, __jsx(ConfirmBoxTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_ConfirmBoxTitle"
      }, "Controleer en bevestig optiespecificatie"), __jsx(RadioContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_RadioContainer"
      }, __jsx(Radio, {
        name: "attachments",
        label: "Akkoord",
        value: "true",
        onChange: this.handleConfirmationSelection,
        "data-id": "homestudio_ProductOptionConfirmModal_Radio"
      })), __jsx(RadioContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_RadioContainer"
      }, __jsx(Radio, {
        name: "attachments",
        label: "Niet akkoord bevonden, omdat...",
        value: "false",
        onChange: this.handleConfirmationSelection,
        "data-id": "homestudio_ProductOptionConfirmModal_Radio"
      })), values.attachmentsReasonVisible && __jsx(TextAreaContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_TextAreaContainer"
      }, __jsx(TextArea, {
        id: "attachmentsReason",
        name: "attachmentsReason",
        title: "Toelichting (verplicht)",
        defaultValue: values.attachmentsReason,
        className: values.attachmentsReason && 'filled',
        onChange: this.handleReasonComment,
        required: false,
        "data-id": "homestudio_ProductOptionConfirmModal_TextArea"
      }))))), data.hasTechnicalDrawing && __jsx(Section, {
        "data-id": "homestudio_ProductOptionConfirmModal_Section"
      }, __jsx(SectionTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_SectionTitle"
      }, "Verwerking op koperstekening"), __jsx(DownloadContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_DownloadContainer"
      }, data.document && data.document.url && __jsx(ButtonDownload, {
        content: data.document.name,
        link: data.document.url,
        "data-id": "homestudio_ProductOptionConfirmModal_ButtonDownload"
      })), __jsx(ConfirmBox, {
        "data-id": "homestudio_ProductOptionConfirmModal_ConfirmBox"
      }, __jsx(ConfirmBoxTitle, {
        "data-id": "homestudio_ProductOptionConfirmModal_ConfirmBoxTitle"
      }, "Controleer en bevestig verwerking op koperstekening"), __jsx(RadioContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_RadioContainer"
      }, __jsx(Radio, {
        name: "additions",
        label: "Akkoord",
        value: "true",
        onChange: this.handleConfirmationSelection,
        "data-id": "homestudio_ProductOptionConfirmModal_Radio"
      })), __jsx(RadioContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_RadioContainer"
      }, __jsx(Radio, {
        name: "additions",
        label: "Niet akkoord bevonden, omdat...",
        value: "false",
        onChange: this.handleConfirmationSelection,
        "data-id": "homestudio_ProductOptionConfirmModal_Radio"
      })), values.additionsReasonVisible && __jsx(TextAreaContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_TextAreaContainer"
      }, __jsx(TextArea, {
        id: "additionsReason",
        name: "additionsReason",
        title: "Toelichting (verplicht)",
        defaultValue: values.additionsReason,
        className: values.additionsReason && 'filled',
        onChange: this.handleReasonComment,
        required: false,
        "data-id": "homestudio_ProductOptionConfirmModal_TextArea"
      })))), __jsx(Section, {
        "data-id": "homestudio_ProductOptionConfirmModal_Section"
      }, canSubmit && hasReason ? __jsx(Paragraph, {
        "data-id": "homestudio_ProductOptionConfirmModal_Paragraph"
      }, "Na het verzenden van deze reactie en toelichting, nemen we deze in behandeling en nemen we contact met je op.") : canSubmit && !hasReason ? __jsx(Fragment, null, __jsx(Paragraph, {
        "data-id": "homestudio_ProductOptionConfirmModal_Paragraph_43"
      }, "Bij akkoord op optiespecificatie en verwerking op koperstekening geef ik opdracht aan ", data.option.commercial_company, " om deze kopersopties te leveren en factureren conform de voorwaarden in de koop-/ aannemingsovereenkomst."), __jsx(CheckboxContainer, {
        "data-id": "homestudio_ProductOptionConfirmModal_CheckboxContainer"
      }, __jsx(Checkbox, {
        id: "requestTerms",
        name: "requestTerms",
        isValid: termsValid,
        validationMessage: "U dient akkoord te gaan met de algemene voorwaarden",
        onChange: this.handleCheckClick,
        "data-id": "homestudio_ProductOptionConfirmModal_Checkbox"
      }, "Ik ga akkoord met de", ' ', __jsx(Link, {
        href: "/".concat(String(projectSlug), "/open/sectionpage/disclaimer"),
        target: "_blank",
        rel: "noopener noreferrer",
        "data-id": "homestudio_ProductOptionConfirmModal_Link"
      }, "algemene voorwaarden")))) : null, __jsx(ButtonPrimary, {
        size: "small",
        type: "button",
        disabled: !canSubmit,
        buttonColor: canSubmit ? colorPalette.blue : colorPalette.lightGrey,
        clickHandler: this.handleSubmit,
        "data-id": "homestudio_ProductOptionConfirmModal_ButtonPrimary"
      }, canSubmit && hasReason ? 'Verzenden' : canSubmit && !hasReason ? 'Naar ondertekenen' : 'Versturen')))) : null;
    }
  }]);
}(Component);
export default withMatch(connectApiData(connect(mapStateToProps, mapDispatchToProps)(ProductOptionConfirmModal)));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n"])), colorPalette.white, shadows.boxPrimary, textStyles.bodyText);
var Content = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 100rem 20rem;\n  "]))));
var Title = styled.h2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), textStyles.pageTitle, colorPalette.headerGrey);
var Section = styled.section(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 40rem;\n  padding-top: 32rem;\n  border-top: 1px dashed ", ";\n"])), colorPalette.lightBeige);
var SubSection = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-top: 40rem;\n  padding-top: 32rem;\n  border-top: 1px solid ", ";\n"])), colorPalette.background);
var SectionTitle = styled.h4(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  letter-spacing: 0.5rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: ", ";\n  margin: 0 0 12rem;\n"])), textStyles.caption, colorPalette.orange);
var SubSectionTitle = styled.h5(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin: 0 0 12rem;\n"])), textStyles.title, colorPalette.headerGrey);
var OptionTitle = styled.h3(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 12rem;\n\n  ", ";\n"])), textStyles.sectionTitle, colorPalette.headerGrey, toBreakpoint.lg(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n    font-size: 24rem;\n  "]))));
var OptionCode = styled.span(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-size: 14rem;\n  margin: 0 0 12rem;\n"])), textStyles.caption, colorPalette.beige);
var OptionPrice = styled.h3(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-weight: normal;\n  margin: 0 0 12rem;\n"])), textStyles.title, colorPalette.headerGrey);
var OptionDescription = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  margin-top: 24rem;\n"])));
var PriceAmountContainer = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-top: 40rem;\n"])));
var PriceAmountTitle = styled.h4(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n  margin: 0 0 8rem;\n"])), textStyles.subTitle);
var PriceAmountLabel = styled.span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: block;\n\n  &:first-of-type {\n    margin-bottom: 32rem;\n  }\n"])));
var DownloadContainer = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin: 16rem 0 40rem;\n"])));
var RadioContainer = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  margin-bottom: 12rem;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])));
var TextAreaContainer = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  margin-top: 16rem;\n"])));
var ConfirmBox = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 32rem 40rem;\n  box-sizing: border-box;\n  background: rgba(", ", 0.25);\n"])), colorPaletteRGB.loadingBlue);
var ConfirmBoxTitle = styled.h5(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 24rem;\n"])), textStyles.title, colorPalette.headerGrey);
var CheckboxContainer = styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  margin-bottom: 32rem;\n"])));